import { useState, useEffect, useRef, useContext } from 'react';
import ApiService from '../../services/ApiService';
import BackImage from "../../background/geom-pattern.jpeg";
import LogoImg from "../../background/rk_landing_01.png";
import LogoImg2 from "../../background/rk_land2.png";
import ExternalLink from "../../background/external_link_icon.svg";
import Navigation from '../../components/navigation';
import LoginForm from '../../components/LoginForm';
import { getLandMap } from "./../../components/different-maps";
import { useNavigate } from 'react-router-dom';
import "./styles.css";

import ArrowDown from "../../assets/arrowDown.svg"
import OurServices from '../../components/OurServices';
import MoreInfo from '../../components/MoreInfo';
import Presentation from '../../components/Presentation';
import Footer from '../../components/Footer';

function Home(props) {
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const [location, setLocation] = useState(null);
  const [loginForm, setLoginForm] = useState(false);
  const [user, setUser] = useState(false);


  useEffect(() => {
    getLocation();
    ApiService.userinfo().then((response) => {
      setUser(response.user);
      props.setUser(response.user);
    });
  }, []);

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }

  function showPosition(position) {
    setLocation(position)
  }

  return <>
    <div className="Home">
      <Navigation
        showLoginForm={() => { setLoginForm(!loginForm); }}
        afterLogout={() => {
          ApiService.userinfo().then((response) => {
            setUser(response.user)
          });
        }}
        user={user}
        isLoginShow={loginForm}
      />
      <div className='background'>
        <img src={BackImage} alt='background' className='background-image' />
      </div>
      <div className='logo-panel'>
        <div className='logo-image'>
          <p className='logo-text'>Робот-Картограф</p>
          <div className="logo-description-container">
            <p className='logo-description-text'>Цифровой адресный план и сервисы на его основе. <br /> С полным адресом, достоверным координатным описанием и множеством собранных и вычисленных характеристик. <br /> Не только в больших городах, а по всей России.</p>
          </div>
          <div className="logo-rk-container">
            <img src={LogoImg} alt='background' className='logo-rk' onClick={() => { navigate('/map?defaultLayers=tms51_layer,RN_1_14:educationOrgs&x=5585440&y=7023154&scale=6') }} />
            <img className='arrowDown' src={ArrowDown} />
          </div>
        </div>
      </div>

      <OurServices />
      {loginForm &&
        <LoginForm
          afterLogin={() => {
            ApiService.userinfo().then((response) => {
              setUser(response.user)
              navigate('/lk/MyDatasets')
            });
            setLoginForm(false);
          }}
        />
      }
      <MoreInfo />
      <Presentation />
      <Footer />
    </div>
  </>
}

export default Home;

